export default "__VITE_ASSET__BDeRAcVQ__"